import { createContext } from "react"

const AccessBuildingContext = createContext();

export default AccessBuildingContext;